import setReduxAction from 'modules/redux/actions/set'
import { joinUpperCaseUnderscoreStringUtil } from 'packages/src'
import {
  TRAINING_APP_ACTION,
  TRAINING_APP_PATH
} from 'modules/training/modules/app/constants/index.js'

export function updateUtmSourceAppAction (value) {
  return dispatch => {
    dispatch(
      setReduxAction({
        type: joinUpperCaseUnderscoreStringUtil(
          TRAINING_APP_ACTION.UPDATE_UTM_SOURCE,
          value
        ),
        payload: {
          value,
          path: TRAINING_APP_PATH.UTM_SOURCE
        }
      })
    )
  }
}
